// 新闻对象
import mAxios from './m-axios'
export interface News {
  id: number
  image: string
  title: string
  desc: string
  url: string
  date: string
}

export const NewNews = (): News => ({
  id: 0,
  image: '',
  title: '',
  desc: '',
  url: '',
  date: '',
})

export const getNewsList = ({offset, limit}) => {
  return mAxios({
    method: 'GET',
    url: '/api/news',
    params: {
      offset: offset,
      limit: limit,
    },
  }).then(res => res.data)
}
